import React from 'react';
import HGClickToCopy from 'components/HGClickToCopy';
import HGStatus from 'components/HGStatus';
import { ViewLogsButton } from 'components/DeviceLogs/ViewLogsButton';
import { aggregateAllAlerts } from 'components/DeviceDetails/helper';
import CounterBadge from 'components/Alerts/CounterBadge';

export const devicesTableColumns = [
    {
        Header: 'Status',
        accessor: 'online',
        component: (item) => {
            const currentTime = Date.now() / 1000;
            const isOnline =
                item.ts && item.ts + 60 * 10 > currentTime ? true : false;
            return <HGStatus online={isOnline} />;
        },
    },
    {
        Header: 'Alerts',
        accessor: 'active_alerts',
        component: (item) => {
            const faultAlarmCount = aggregateAllAlerts(item.active_alerts);
            return <CounterBadge item={faultAlarmCount} />;
        },
    },
    {
        Header: 'Name',
        accessor: 'ThingName',
    },
    {
        Header: 'Serial No.',
        accessor: 'SerialNumber',
        component: (item) => (
            <HGClickToCopy content={item?.SerialNumber}>
                <span className="text-foreground">{item?.SerialNumber}</span>
            </HGClickToCopy>
        ),
    },
    {
        Header: 'Device Type',
        accessor: 'ThingType',
    },
    {
        Header: 'Logs',
        accessor: 'online',
        component: (item) => (
            <ViewLogsButton device={item}>View Logs</ViewLogsButton>
        ),
        nosort: true,
    },
];
